var _excluded = ["size", "color", "children", "className", "Icon", "disabled", "isClosable", "onRequestClose"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useTheme } from '@creditas-ui/system';
import { IconDeleteDisabled } from '@creditas-ui/icons';
import { TagElement } from './Tag.style';
import { GlobalIcons, ButtonIcon, Label } from './components';
export var Tag = _ref => {
  var {
    size = 'medium',
    color = 'primary',
    children,
    className,
    Icon,
    disabled,
    isClosable,
    onRequestClose
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    tag
  } = useTheme();
  return /*#__PURE__*/React.createElement(TagElement, _extends({
    "data-testid": "tag-component",
    className: className,
    size: size,
    color: color,
    disabled: disabled
  }, props), Icon && /*#__PURE__*/React.createElement(GlobalIcons, {
    "data-testid": "tag-icon",
    Icon: Icon,
    size: size,
    disabled: disabled,
    color: tag('base.icons.icon.color'),
    marginRight: tag("base.icons.icon.sizeContainer.".concat(size, ".marginRight"))
  }), /*#__PURE__*/React.createElement(Label, {
    size: size,
    disabled: disabled,
    variant: "bodyXsRegular",
    component: "small"
  }, children), isClosable && onRequestClose && /*#__PURE__*/React.createElement(ButtonIcon, {
    as: "button",
    Icon: IconDeleteDisabled,
    size: size,
    disabled: disabled,
    onClick: onRequestClose,
    color: tag('base.icons.closeIcon.color'),
    marginLeft: tag('base.icons.closeIcon.marginLeft')
  }));
};
//# sourceMappingURL=Tag.js.map